import { BellOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';
import { FC, useEffect, useState } from 'react';

import { requestFcmTokenAndRegister } from 'src/utils/firebase/firebase-messaging';
import {
  getNotificationPermission,
  requestNotificationPermission,
  unlockNotificationSound,
} from 'src/utils/notifications/browserNotification';

import { useAuth } from 'src/stores/auth-context';

import classes from './PermissionBanner.module.scss';

const DISMISS_KEY = 'chatNotifyBannerDismissed';

const PermissionBanner: FC = () => {
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (user?.role !== 'admin') {
      setVisible(false);
      return;
    }
    const permission = getNotificationPermission();
    const dismissed = localStorage.getItem(DISMISS_KEY) === '1';
    setVisible(permission === 'default' && !dismissed);
  }, [user?.role]);

  const handleAllow = async () => {
    const result = await requestNotificationPermission();
    unlockNotificationSound();
    if (result === 'granted') {
      message.success('브라우저 알림이 활성화되었습니다.');
      if (user?._id) {
        requestFcmTokenAndRegister(user._id).catch((error) => {
          console.warn('[PermissionBanner] FCM token register failed', error);
        });
      }
    } else if (result === 'denied') {
      message.warning('알림이 차단되었습니다. 브라우저 설정에서 다시 허용할 수 있습니다.');
    }
    setVisible(false);
  };

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={classes.banner}>
      <span>
        <BellOutlined style={{ marginRight: 6 }} />
        고객 채팅을 놓치지 않도록 브라우저 알림을 켜주세요.
      </span>
      <div className={classes.actions}>
        <Button type='primary' size='small' onClick={handleAllow}>
          허용
        </Button>
        <Button type='text' size='small' onClick={handleDismiss}>
          나중에
        </Button>
      </div>
    </div>
  );
};

export default PermissionBanner;
